import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Select } from 'antd';
import { AccountModalSelector, Form, LocationInput } from '~/components';
import { usePath } from '~/hooks';
import { inputWidth } from '~/utils/filters';

const Filters: FC<any> = () => {
  const [form] = Form.useForm();
  const { changePath, params } = usePath();
  const { t } = useTranslation('terminals');

  const handleChange = (_changed: any, values: Record<string, any>) => {
    changePath({ filter: values });
  };

  return (
    <Form form={form} layout="inline" onValuesChange={handleChange} initialValues={params.filter}>
      <Form.Item name="status">
        <Select
          allowClear
          placeholder={t('status:status')}
          options={[
            { value: 'ACTIVE', label: t('status:ACTIVE') },
            { value: 'CLOSED', label: t('status:CLOSED') },
            { value: 'NOT_ACTIVATED', label: t('status:NOT_ACTIVATED') },
          ]}
          style={inputWidth}
        />
      </Form.Item>
      <Form.Item name="terminalType">
        <Select
          allowClear
          placeholder={t('type')}
          options={[
            { value: 'MPOS', label: t('MPOS') },
            { value: 'ECOMMERCE', label: t('ECOMMERCE') },
          ]}
          style={inputWidth}
        />
      </Form.Item>
      <AccountModalSelector
        selectorForm={form}
        name="accountId"
        selectMode="single"
        label={undefined}
        placeholder={t('account')}
        style={inputWidth}
        onChange={() => {
          changePath({
            filter: {
              ...form.getFieldsValue(),
              accountId: form.getFieldValue('accountId'),
            },
          });
        }}
      />
      <Form.Item name="locationId">
        <LocationInput placeholder={t('location')} style={inputWidth} allowClear />
      </Form.Item>
    </Form>
  );
};

export default Filters;
